module.exports = __webpack_public_path__ + "img/ic-menu-more.dd93e15f.svg";